import React from "react";
import { scroller } from "react-scroll";
import { FaCheck, FaStar } from "react-icons/fa";

const plans = [
  {
    name: "Fillestare",
    tagline: "Për biznese që duan prani profesionale online",
    priceLabel: "nga",
    priceAmount: "€490",
    featured: false,
    features: [
      "Faqe prezantimi deri 5 faqe",
      "Dizajn modern & plotësisht responsive",
      "Formë kontakti funksionale",
      "Setup domain & hosting",
      "Optimizim bazë SEO",
      "Dorëzim brenda 7 ditësh",
    ],
    cta: "Fillo sot",
  },
  {
    name: "Profesionale",
    tagline: "Për startup dhe biznese në rritje",
    priceLabel: "nga",
    priceAmount: "€1,490",
    featured: true,
    features: [
      "Web aplikacion ose App Mobile (iOS & Android)",
      "Dizajn UI/UX i personalizuar",
      "Backend & integrim API",
      "Panel admin (dashboard)",
      "60 ditë mbështetje pas lançimit",
      "Raportim performancë & analitikë",
    ],
    cta: "Kërko propozim",
  },
  {
    name: "Ndërmarrje",
    tagline: "Për organizata me nevoja komplekse",
    priceLabel: null,
    priceAmount: "Me çmim të personalizuar",
    featured: false,
    features: [
      "Platforma të shkallëzueshme & komplekse",
      "Integrimi i Inteligjencës Artificiale (AI)",
      "Automatizim procesesh & workflow-sh",
      "Zgjerim i ekipit tuaj teknologjik",
      "SLA me kohë reagimi prioritar",
      "Mbështetje e dedikuar & dokumentacion",
    ],
    cta: "Na kontakto",
  },
];

function Pricing() {
  const scrollTo = (target) =>
    scroller.scrollTo(target, { smooth: true, duration: 550, offset: -96 });

  return (
    <section className="pricing section-pad" id="pricing">
      <div className="container">
        <div className="section-heading">
          <span className="section-tag">Çmimet</span>
          <h2>Paketa transparente, pa surpriza</h2>
          <p>
            Çdo projekt fillon me propozim të detajuar me shkrim. Ju dini çfarë
            përfshihet, kur dorëzohet dhe sa kushton — para se të fillojmë ndonjë
            punë.
          </p>
        </div>

        <div className="pricing-grid">
          {plans.map(({ name, tagline, priceLabel, priceAmount, featured, features, cta }) => (
            <article
              key={name}
              className={`pricing-card${featured ? " pricing-card--featured" : ""}`}
            >
              {featured && (
                <div className="pricing-badge">
                  <FaStar aria-hidden="true" />
                  <span>Më e zgjedhura</span>
                </div>
              )}

              <div className="pricing-header">
                <h3 className="pricing-name">{name}</h3>
                <p className="pricing-tagline">{tagline}</p>
                <div className="pricing-price">
                  {priceLabel && (
                    <span className="pricing-from">{priceLabel}</span>
                  )}
                  <span className={priceLabel ? "pricing-amount" : "pricing-amount pricing-amount--custom"}>
                    {priceAmount}
                  </span>
                </div>
              </div>

              <ul className="pricing-features">
                {features.map((f) => (
                  <li key={f}>
                    <FaCheck className="pricing-check" aria-hidden="true" />
                    <span>{f}</span>
                  </li>
                ))}
              </ul>

              <button
                type="button"
                className={
                  featured
                    ? "primary-btn pricing-btn"
                    : "secondary-btn pricing-btn"
                }
                onClick={() => scrollTo("contact")}
              >
                {cta}
              </button>
            </article>
          ))}
        </div>

        <p className="pricing-note">
          Çmimet variojnë sipas kompleksitetit dhe fushëveprimit të projektit.
          Na kontaktoni për vlerësim falas dhe propozim brenda 24 orësh.
        </p>
      </div>
    </section>
  );
}

export default Pricing;
